import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { IUserBackend } from '../../../entity/User'
import { getUrlWithVersion } from '../../../api/api'

export const fetchUsers = createAsyncThunk<
    IUserBackend[],
    void,
    ThunkConfig<string>
>('userSlice/fetchUsers', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get<IUserBackend[]>(getUrlWithVersion(`/users`))
        return data
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch users')
    }
})